import styled from 'styled-components';
import { Skeleton, theme } from '@frameio/vapor';
import { IconFolderClosed } from '@frameio/vapor-icons';
import { CHEVRON_WIDTH, ICON_WIDTH, ITEM_HEIGHT } from './ItemContainer';

type Props = {
  paddingLeft: number;
};

export const ItemSkeleton = ({ paddingLeft }: Props) => (
  <Container
    style={{
      height: theme.spaces[ITEM_HEIGHT],
      paddingLeft: paddingLeft + CHEVRON_WIDTH + CHEVRON_PADDING,
    }}
  >
    <IconFolderClosed color={theme.colors.icon.secondary} size={ICON_WIDTH} />
    <Skeleton
      height={SKELETON_HEIGHT}
      style={{ marginLeft: SKELETON_MARGIN }}
      width={SKELETON_WIDTH}
    />
  </Container>
);

const Container = styled.div`
  align-items: center;
  display: inline-flex;
`;

const CHEVRON_PADDING = 6;
const SKELETON_HEIGHT = '10px';
const SKELETON_MARGIN = 8;
const SKELETON_WIDTH = '100px';
